module.exports = __webpack_public_path__ + "static/img/mobile_crm.ba508e2e.png";